import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 90,
        damping: 25,
        mass: 0.4,
    });

    return (
        <motion.div
            data-testid="scroll-progress-bar"
            aria-hidden="true"
            className="fixed left-0 right-0 top-0 z-[130] h-[2px] origin-left bg-gold"
            style={{ scaleX }}
        />
    );
}
